module.exports = __webpack_public_path__ + "64ae54bdc34260769137fcd45c845d8c.png";